import { StackedCellText } from '@/components/common/DataTable';
import { EmptyValue } from '@/components/common/EmptyValue';
import { HighlightText } from '@/components/common/HighlightText';
import type { MeetPerson } from '@/types/meetPerson.types';

interface MeetPeopleCellProps {
  meetPeople: MeetPerson[];
  highlightedText?: string | undefined;
}

interface MeetPersonMobileProps {
  mobile: string;
  highlightedText: string | undefined;
}

function MeetPersonMobile({ mobile, highlightedText }: MeetPersonMobileProps) {
  return (
    <span className="whitespace-nowrap tabular-nums">
      <HighlightText text={mobile} highlightedText={highlightedText} />
    </span>
  );
}

export function MeetPeopleCell({ meetPeople, highlightedText }: MeetPeopleCellProps) {
  if (meetPeople.length === 0) return <EmptyValue />;

  return (
    <span className="flex flex-col gap-1.5">
      {meetPeople.map((person) => {
        const mobile = (
          <MeetPersonMobile mobile={person.mobile} highlightedText={highlightedText} />
        );
        return (
          <StackedCellText
            key={person.mobile}
            primary={
              person.name ? (
                <HighlightText text={person.name} highlightedText={highlightedText} />
              ) : (
                mobile
              )
            }
            secondary={person.name ? mobile : null}
          />
        );
      })}
    </span>
  );
}
